// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThemeNavigation_activeLinkDarkTheme__8Gppt {
  font-size: 17px;
  font-weight: bold;
  position: relative;
  color: #fff;
}
.ThemeNavigation_activeLinkBrightTheme__8vDdA {
  font-size: 17px;
  font-weight: bold;
  position: relative;
  color: #000;
}
/* .activeLink::before {
  content: "";
  position: absolute;
  margin-block-start: 24px;
  margin-inline-start: 35px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #6734d6;
} */
.ThemeNavigation_whiteThemeActiveDot__mX6Ik::before,
.ThemeNavigation_pinkThemeActiveDot__yabuK::before,
.ThemeNavigation_gradientThemeActiveDot__Lj637::before,
.ThemeNavigation_BlueThemeActiveDot__cB1mp::before {
  content: "";
  position: absolute;
  margin-block-start: 24px;
  margin-inline-start: 30px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #6734d6;
}
.ThemeNavigation_darkThemeActiveDot__fhGpJ::before {
  content: "";
  position: absolute;
  margin-block-start: 24px;
  margin-inline-start: 30px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #3963b8;
}
.ThemeNavigation_bb__GTR3a {
  color: inherit;
  font-size: 17px;
  font-weight: bold;
  position: relative;
}
.ThemeNavigation_bb__GTR3a .ThemeNavigation_navIcon__avrS1 {
  margin-inline-start: 8px !important;
  transform: scale(1.2);
  transition: all 0.3s ease-out !important;
}
.ThemeNavigation_line__Hx6-4 {
  background-color: #9a9a9a;
  height: 1px;
  margin-inline: 28px;
}
.ThemeNavigation_activeLink__gpH\\+g .ThemeNavigation_nestedLink__M8ABU {
  transition: all 0.3s ease-out !important;
  margin-inline-start: 5px !important;
}
.ThemeNavigation_activeUCDarkTheme__fSfiv {
  font-size: 17px !important ;
  font-weight: 500 !important ;
  color: #fff;
}
.ThemeNavigation_activeUCBrightTheme__IkrFm {
  font-size: 17px !important ;
  font-weight: 500 !important ;
  color: #000;
}
.ThemeNavigation_spanIconContainer__ZfXOW {
  direction: inherit !important;
}
.ThemeNavigation_navLabel__AzWum {
  width: calc(100% - 41px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Layout/ThemeNavigation/ThemeNavigation.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;AACA;;;;;;;;;GASG;AACH;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,wCAAwC;AAC1C;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".activeLinkDarkTheme {\r\n  font-size: 17px;\r\n  font-weight: bold;\r\n  position: relative;\r\n  color: #fff;\r\n}\r\n.activeLinkBrightTheme {\r\n  font-size: 17px;\r\n  font-weight: bold;\r\n  position: relative;\r\n  color: #000;\r\n}\r\n/* .activeLink::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  margin-block-start: 24px;\r\n  margin-inline-start: 35px;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background-color: #6734d6;\r\n} */\r\n.whiteThemeActiveDot::before,\r\n.pinkThemeActiveDot::before,\r\n.gradientThemeActiveDot::before,\r\n.BlueThemeActiveDot::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  margin-block-start: 24px;\r\n  margin-inline-start: 30px;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background-color: #6734d6;\r\n}\r\n.darkThemeActiveDot::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  margin-block-start: 24px;\r\n  margin-inline-start: 30px;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background-color: #3963b8;\r\n}\r\n.bb {\r\n  color: inherit;\r\n  font-size: 17px;\r\n  font-weight: bold;\r\n  position: relative;\r\n}\r\n.bb .navIcon {\r\n  margin-inline-start: 8px !important;\r\n  transform: scale(1.2);\r\n  transition: all 0.3s ease-out !important;\r\n}\r\n.line {\r\n  background-color: #9a9a9a;\r\n  height: 1px;\r\n  margin-inline: 28px;\r\n}\r\n.activeLink .nestedLink {\r\n  transition: all 0.3s ease-out !important;\r\n  margin-inline-start: 5px !important;\r\n}\r\n.activeUCDarkTheme {\r\n  font-size: 17px !important ;\r\n  font-weight: 500 !important ;\r\n  color: #fff;\r\n}\r\n.activeUCBrightTheme {\r\n  font-size: 17px !important ;\r\n  font-weight: 500 !important ;\r\n  color: #000;\r\n}\r\n.spanIconContainer {\r\n  direction: inherit !important;\r\n}\r\n.navLabel {\r\n  width: calc(100% - 41px);\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"activeLinkDarkTheme": `ThemeNavigation_activeLinkDarkTheme__8Gppt`,
	"activeLinkBrightTheme": `ThemeNavigation_activeLinkBrightTheme__8vDdA`,
	"whiteThemeActiveDot": `ThemeNavigation_whiteThemeActiveDot__mX6Ik`,
	"pinkThemeActiveDot": `ThemeNavigation_pinkThemeActiveDot__yabuK`,
	"gradientThemeActiveDot": `ThemeNavigation_gradientThemeActiveDot__Lj637`,
	"BlueThemeActiveDot": `ThemeNavigation_BlueThemeActiveDot__cB1mp`,
	"darkThemeActiveDot": `ThemeNavigation_darkThemeActiveDot__fhGpJ`,
	"bb": `ThemeNavigation_bb__GTR3a`,
	"navIcon": `ThemeNavigation_navIcon__avrS1`,
	"line": `ThemeNavigation_line__Hx6-4`,
	"activeLink": `ThemeNavigation_activeLink__gpH+g`,
	"nestedLink": `ThemeNavigation_nestedLink__M8ABU`,
	"activeUCDarkTheme": `ThemeNavigation_activeUCDarkTheme__fSfiv`,
	"activeUCBrightTheme": `ThemeNavigation_activeUCBrightTheme__IkrFm`,
	"spanIconContainer": `ThemeNavigation_spanIconContainer__ZfXOW`,
	"navLabel": `ThemeNavigation_navLabel__AzWum`
};
export default ___CSS_LOADER_EXPORT___;
